<template>
  <div class="investor_particulars">
    <van-tabs
      :title-active-color="'#36B374'"
      :title-inactive-color="'#333333'"
      :line-width="'46px'"
      :line-height="'2px'"
    >
      <van-tab title="投资方详情">
        <div class="body">
          <div class="information">
            <table class="table">
              <tr>
                <td class="name">企业名称：</td>
                <td>{{details.companyName}}</td>
              </tr>
              <tr>
                <td class="name">统一社会信用代码：</td>
                <td>{{details.uscCode}}</td>
              </tr>
              <tr>
                <td class="name">区域：</td>
                <td>{{details.areaName}}</td>
              </tr>
              <tr>
                <td class="name">企业排行：</td>
                <td>{{details.rankingName}}</td>
              </tr>
              <tr>
                <td class="name">联系人：</td>
                <td>{{details.contacts}}</td>
              </tr>
              <tr>
                <td class="name">联系电话：</td>
                <td v-if="contractPhoneShow">{{details.contactNumber}}</td>
                <td v-else>{{ getPhone(details.contactNumber) }}<span class="view" @click="contractPhoneShow = true">查看</span> </td>
              </tr>
              <tr>
                <td class="name">公司地址：</td>
                <td>{{details.companyAddress}}</td>
              </tr>
              <tr>
                <td class="name">公司简介：</td>
                <td>{{details.companyProfile}}</td>
              </tr>
              <tr>
                <td class="name">投资意向：</td>
                <td>{{details.investmentIntention}}</td>
              </tr>
              <tr>
                <td class="name">投资问题：</td>
                <td>{{details.investmentIssues}}</td>
              </tr>
              <tr>
                <td class="name">创建人：</td>
                <td>{{details.creatorName}}</td>
              </tr>
              <tr>
                <td class="name">创建时间：</td>
                <td>{{details.createTime}}</td>
              </tr>
            </table>
            <!-- <div class="content">
              <div>
                <span class="name">企业名称：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="price">{{details.companyName}}</span>
              </div>
              <div>
                <span class="name">统一社会信用代码：</span>
                <span class="price">{{details.uscCode}}</span>
              </div>
              <div>
                <span class="name">区域：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="price">{{details.areaName}}</span>
              </div>
              <div>
                <span class="name">企业排行：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="price">{{details.rankingName}}</span>
              </div>
              <div>
                <span class="name">联系人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="price">{{details.contacts}}</span>
              </div>
              <div>
                <span class="name">联系电话：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="price">{{details.contactNumber}}</span>
              </div>
              <div>
                <span class="name">公司地址：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="price">{{details.companyAddress}}</span>
              </div>
              <div>
                <span class="name">公司简介：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="price">{{details.companyProfile}}</span>
              </div>
              <div>
                <span class="name">投资意向：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="price">{{details.investmentIntention}}</span>
              </div>
              <div>
                <span class="name">投资问题：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="price">{{details.investmentIssues}}</span>
              </div>
              <div>
                <span class="name">创建人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="price">{{details.creatorName}}</span>
              </div>
              <div>
                <span class="name">创建时间：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                <span class="price">{{details.createTime}}</span>
              </div>
            </div>-->
          </div>
          <div class="information_bottom" v-if="details.photoPath.length">
            <div class="top">
              <img v-for="(item,index) in details.photoPath" :key="index" :src="item" alt />
            </div>
          </div>
          <div class="foot" v-if="isSupervision !== 'supervision'">
          <!-- <div class="foot"> -->
              <button @click="delInvestorHandle()">删除</button>
          </div>
        </div>
      </van-tab>
      <van-tab title="对接洽谈记录">
        <div class="record">
          <van-dropdown-menu>
            <van-dropdown-item
              v-model="negotiate_request.dockingModeCode"
              :options="fashion"
              @change="onRefresh"
            />
          </van-dropdown-menu>
          <div class="record_list">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
                :error.sync="error"
                error-text="请求失败，点击重新加载"
              >
                <listInvestorParticulars
                  v-for="(item,index) in record_list"
                  :key="index"
                  :record="item"
                ></listInvestorParticulars>
              </van-list>
            </van-pull-refresh>
          </div>
        </div>
      </van-tab>
      <van-tab title="投资项目">
        <div class="project_list">
          <van-pull-refresh v-model="pt_refreshing" @refresh="onPtRefresh">
            <van-list
              v-model="pt_loading"
              :finished="pt_finished"
              finished-text="没有更多了"
              @load="onPtLoad"
              :error.sync="pt_error"
              error-text="请求失败，点击重新加载"
            >
              <listInvestorParticularsProject
                v-for="(item,index) in clause_list"
                :key="index"
                :record="item"
              ></listInvestorParticularsProject>
            </van-list>
          </van-pull-refresh>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Vue from "vue";
import { Tab, Tabs, DropdownMenu, DropdownItem, Dialog, Notify } from "vant";

import listInvestorParticulars from "../components/listInvestorParticulars";
import listInvestorParticularsProject from "../components/listInvestorParticularsProject";

import api from '../../../service/modules/investment'

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Tab);
Vue.use(Tabs);
export default {
  name: "investorParticulars",
  components: {
    listInvestorParticulars,
    listInvestorParticularsProject
  },
  props: {},
  data() {
    return {
      fashion: [
        { text: "洽谈方式", value: "" },
        { text: "拜访考察企业", value: 0 },
        { text: "客商来滇考察", value: 1 },
        { text: "会见客商", value: 2 },
        { text: "电话洽谈", value: 3 },
        { text: "邮件往来", value: 4 },
        { text: "远程会议", value: 5 },
        { text: "其他", value: 6 }
      ],
      details: {
        photoPath: []
      },
      record_list: [],
      contractPhoneShow: false, // 联系电话显示
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      pt_loading: false,
      pt_finished: false,
      pt_refreshing: false,
      pt_error: false,
      pt_error_true: false,
      error_true: false,
      negotiate_request: {
        current: 0,
        pageSize: 10,
        investorInfoId: "",
        dockingModeCode: ""
      },
      clause_request: {
        id: "", //企业id – 必传
        current: 0, //当前页
        pageSize: 10 //每页条数
      },
      clause_list: []
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    type() {
      return this.$route.query.type;
    },
    isCanDelete() {
      return this.$route.query.isCanDelete
    },
    isSupervision() {
      return localStorage.getItem('attractRole')
    }
  },
  watch: {},
  methods: {
    ...mapActions("investment", [
      "setInvestmentTitle",
      "getInvestorInfo",
      "getDockingNegotiateList",
      "getInvestorProjectList",
      "getAllLocation",
      "delInvestor"
    ]),
    // 删除投资方
    delInvestorHandle() {
      if (!this.isCanDelete) {
        Notify({ type: 'danger', message: "该投资方不允许删除！" });
        return;
      }
      Dialog.confirm({
        title: '删除',
        message: '是否确认删除',
      }).then(() => {
        try {
          api.delInvestor({ ids: this.details.id }).then(res => {
            if (res.code === 0) {
              Notify({ type: "success", message: "操作成功" });
              setTimeout(() => {
                this.$router.push({ path: "/investment/investor" });
              }, 1500);
            }
          })
        } catch(err) {
          console.log(err)
        }
        // this.delInvestor(formData).then(res => {
        //   if (res.code === 0) {
        //     Notify({ type: "success", message: "操作成功" });
        //     setTimeout(() => {
        //       this.$router.push({ path: "/investment/investor" });
        //     }, 1500);
        //   }
        // }).catch(res => {
        //   Notify({ type: 'danger', message: res.msg });
        // })
      }).catch(() => {
        // on cancel
      });
    },
    refreshDockingNegotiateList() {
      this.negotiate_request.investorInfoId = this.id;

      this.getDockingNegotiateList(this.negotiate_request)
        .then(res => {
          this.refreshing = false;
          this.loading = false;
          this.error_true = false;
          if (res.pages > this.negotiate_request.current) {
            this.finished = false;
          } else {
            this.finished = true;
          }

          this.record_list = this.record_list.concat(res.records);
        })
        .catch(res => {
          this.refreshing = false;
          this.loading = false;
          this.finished = false;
          this.error = true;
          this.error_true = true;
        });
    },
    refreshInvestorProjectList() {
      this.clause_request.id = this.id;

      this.getInvestorProjectList(this.clause_request)
        .then(res => {
          this.pt_refreshing = false;
          this.pt_loading = false;
          this.pt_error_true = false;

          if (res.pages > this.clause_request.current) {
            this.pt_finished = false;
          } else {
            this.pt_finished = true;
          }

          this.clause_list = this.clause_list.concat(res.records);
          console.log('clause_list', this.clause_list)
        })
        .catch(res => {
          this.pt_refreshing = false;
          this.pt_loading = false;
          this.pt_finished = false;
          this.pt_error = true;
          this.pt_error_true = true;
        });
    },
    onLoad() {
      console.log("加载下一页");
      if (!this.error_true) {
        this.negotiate_request.current++;
      }
      this.refreshDockingNegotiateList();
    },
    //下拉刷新时触发
    onRefresh() {
      this.negotiate_request.current = 1;
      this.record_list = [];
      this.refreshDockingNegotiateList();
    },
    onPtLoad() {
      console.log("加载下一页");
      if (!this.pt_error_true) {
        this.clause_request.current++;
      }
      this.refreshInvestorProjectList();
    },
    //下拉刷新时触发
    onPtRefresh() {
      this.clause_request.current = 1;
      this.clause_list = [];
      this.refreshInvestorProjectList();
    },
    getPhone(value) {
      let phone = value + ''
      return phone.substr(0, 2) + '******' + phone.substr(phone.length - 2)
    },
  },
  created() {
    console.log('目前是监管嘛', localStorage.getItem('attractRole'))
    this.$store.state.investment.investorAreaCode = this.$route.query.areaCode
    this.setInvestmentTitle("投资方详情");
    this.getAllLocation();
    this.getInvestorInfo({ id: this.id }).then(res => {
      res.photoPath = res.photoPath ? res.photoPath.split("◎") : [];
      res.createTime = res.createTime
        ? res.createTime.replace(/T/g, " ").replace(/Z/g, "")
        : "";

      this.details = res;
    });
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.investor_particulars {
  min-height: 100%;
  font-family: PingFangSC-Regular;
  background: #f5f6f9;
  /deep/.van-tabs__line {
    background-color: #36b374;
  }
  /deep/.van-tabs__nav--line {
    .van-tab {
      flex: none;
      padding-left: 12px;
      padding-right: 12px;
    }
  }
  /deep/.van-tab__text--ellipsis {
    line-height: 20px;
  }
  .body {
    padding: 12px 12px 106px;
  }
  .information {
    background: #ffffff;
    padding: 0 20px 12px;
    margin-bottom: 12px;
    border-radius: 3px;
    table {
      table-layout: fixed;
      width: 100%;
      word-wrap: break-word;
      text-overflow: ellipsis;
      font-size: 12px;
      line-height: 17px;
      td {
        padding-top: 12px;
        padding-right: 8px;
        vertical-align: top;
        white-space: normal;
      }
      .name {
        white-space: nowrap;
        margin-right: 8px;
        width: 108px;
      }
    }
    .content {
      color: #333333;
      font-size: 12px;
      line-height: 17px;
      div {
        padding-top: 12px;
        display: flex;
        justify-content: flex-start;
        word-break: break-all;

        .name {
          white-space: nowrap;
          margin-right: 8px;
        }
        .price {
        }
      }
    }
  }
  .information_bottom {
    background: #ffffff;
    padding: 12px;
    margin-bottom: 12px;
    border-radius: 3px;

    .top {
      img {
        width: 100%;
        margin-bottom: 16px;
      }
    }
  }
  .foot {
    position: fixed;
    bottom: 0;
    left: 0;
    bottom: 0;
    padding: 13px 12px 47px;
    background: #ffffff;
    width: 100%;
    button {
      border: 0;
      background: #36b374;
      display: block;
      width: 100%;
      padding: 13px;
      line-height: 22px;
      font-size: 16px;
      color: #ffffff;
      border-radius: 3px;
    }
  }
  .record {
    /deep/.van-dropdown-menu__bar {
      background-color: transparent;
      box-shadow: none;
    }
    /deep/.van-dropdown-menu__item {
      flex: none;
    }
    /deep/.van-dropdown-menu__title {
      padding-left: 12px;
    }
    .record_list {
      padding: 0 12px 1px;
    }
  }
  .project_list {
    padding: 12px 12px 1px;
  }
}
.view {
  color: #36b374;
  margin-left: 5px;
}
</style>